export default __webpack_public_path__ + "static/media/sc-bc-ico.ff507498.svg";